import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';
import { buttonClass, type ButtonSize, type ButtonVariant } from './variants.ts';

/**
 * shadcn-Button mit TILLTOOLS-Markenschicht: Pille, Hauptknopf in TILL-Dunkelblau mit Hover (Change 03.10.2026 Design E ·
 * final), Zweitknopf als S3-Chip – hell durchscheinend mit feinem Rand (Change 11.10.2026 Design S3). Höhe 44 px =
 * Trefferfläche bei Touch. Seit Ticket 1.241 als Opt-in: `variant="danger"` (Gefahr-Rot, z. B. „Löschen“) und
 * `size="sm"` (38 px, `--button-h`, Entwürfe 16.10.2026); ohne Angabe bleibt alles wie bisher.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  type = 'button',
  ...props
}: ComponentProps<'button'> & { variant?: ButtonVariant; size?: ButtonSize }) {
  return <button type={type} className={cn(buttonClass(variant, size), className)} {...props} />;
}
